import React from 'react';
import { RectShape } from 'react-placeholder/lib/placeholders';

const FeaturedCoursePlaceHolder = (
  <div className='row'>
    <div className="col-10 col-sm-3 mb-3">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-10 col-sm-3 mb-3">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-10 col-sm-3 mb-3">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-10 col-sm-3 mb-3">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-10 col-sm-3 mb-3">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-10 col-sm-3 mb-3">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-10 col-sm-3 mb-3">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
    <div className="col-10 col-sm-3 mb-3">
      <div className="course-card featured place-holder disabled">
        <RectShape color='lightgray' style={{ marginRight: 0 }} />
      </div>
    </div>
  </div>
);

export default FeaturedCoursePlaceHolder;
